import { Table, TableContainer } from '@ksyos/design-system';
import type { IProcessActivityWithChecked } from '@frontend/components/interfaces';
import { PaymentsTableBody } from './PaymentsTableBody';
import { PaymentsTableHead } from './PaymentsTableHead';

interface IPaymentsTableProps {
    allPaymentItemsSelected: boolean;
    items: IProcessActivityWithChecked[];
    onSelectAllPaymentItems: (value: boolean) => void;
    onSelectPaymentItem: (value: boolean, index: number) => void;
    reprocessedActivities: string[];
}

export function PaymentsTable(props: Readonly<IPaymentsTableProps>) {
    return (
        <TableContainer>
            <Table>
                <PaymentsTableHead
                    allPaymentItemsSelected={props.allPaymentItemsSelected}
                    items={props.items}
                    onSelectAllPaymentItems={props.onSelectAllPaymentItems}
                />
                <PaymentsTableBody
                    items={props.items}
                    onSelectPaymentItem={props.onSelectPaymentItem}
                    reprocessedActivities={props.reprocessedActivities}
                />
            </Table>
        </TableContainer>
    );
}
